module.exports = __webpack_public_path__ + "img/oceanfront.190e2421.png";